import { Icon, type IconProps } from "@chakra-ui/react";
import React from "react";

export function SunshineIcon(props: IconProps) {
  return (
    <Icon width="20px" height="20px" viewBox="0 0 20 20" fill="none" {...props}>
      <path
        d="M10 16.818v1.515M14.818 14.818l1.076 1.076M4.106 15.894l1.076-1.076M16.818 10h1.515M1.667 10h1.515M10 13.788a3.788 3.788 0 1 0 0-7.576 3.788 3.788 0 0 0 0 7.576ZM14.818 5.181l1.076-1.076M4.106 4.105l1.076 1.076"
        stroke="currentColor"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path d="M10 1.667v1.515" stroke="currentColor" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round" />
    </Icon>
  );
}
